export const isSwitchToAllGroupBy = (
  requestTypes: Array<string>,
  currentRequestType: string
): boolean => {
  if (requestTypes.length === 1) {
    return requestTypes[0] !== currentRequestType;
  }

  if (requestTypes.length > 1 || requestTypes.length === 0) {
    return true;
  }

  return false;
};
